import { useCallback, useRef } from "react";

/** Keeps onError stable so fetch hooks do not re-run in an infinite loop. */
export const useStableOnError = (
  onError?: (error: Error) => void
): ((error: Error) => void) => {
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  return useCallback((error: Error) => {
    onErrorRef.current?.(error);
  }, []);
};
